export default {
  INSERT: 'INSERT',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE'
};



// WEBPACK FOOTER //
// ./src/components/common/event-crud-types.js